<template>
    <div class="file-upload-wrapper mb-3">
        <label class="label mb-2">
            {{ prestation.label_attachment ?? 'Joindre un fichier' }}
            <span v-if="prestation.force_attachment" class="required">*</span>
        </label>


         <!-- Cas où il y a déjà un fichier -->
        <div v-if="attachment" class="file-upload-label d-flex column align-items-start gap-1 position-relative">
            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19L17 21L21 17M13 3H8.2C7.0799 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.0799 21 8.2 21H12M13 3L19 9M13 3V7.4C13 7.96005 13 8.24008 13.109 8.45399C13.2049 8.64215 13.3578 8.79513 13.546 8.89101C13.7599 9 14.0399 9 14.6 9H19M19 9V13.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="file-text">
                <strong>Fichier actuel: {{ fileName }}</strong><br>
                <span>{{ getDisplaySize() }}</span>
                <span v-if="attachment.isExisting" class="text-muted"> (Fichier existant)</span>
            </span>
            
            <!-- Bouton pour changer le fichier -->
            <label for="attachment-extra" class="btn btn-outline-secondary btn-sm mt-2">
                Changer le fichier
            </label>
            
            <!-- Bouton pour supprimer -->
            <button
                type="button"
                class="position-absolute btn-close"
                @click.stop="handleRemoveFile()"
                aria-label="Supprimer le fichier"
            ></button>
            
            <input 
                type="file" 
                id="attachment-extra" 
                name="attachment" 
                @change="setAttachment" 
                class="d-none"
            />
        </div>


        <label v-else-if="!attachment" for="attachment-extra" class="file-upload-label d-flex column align-items-start gap-1">
            <input type="file" id="attachment-extra" name="attachment" @change="setAttachment" class="d-none"/>
            <svg fill="#000000" width="50" height="50" viewBox="0 0 32 32">
                <path d="M27,15v5a5,5,0,0,1-5,5H10a5,5,0,0,1-5-5V15a1,1,0,0,1,2,0v5a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3V15a1,1,0,0,1,2,0ZM16,20a1,1,0,0,0,1-1V8.87l4.45,3a1,1,0,1,0,1.11-1.66l-6-4a1,1,0,0,0-1.11,0l-6,4a1,1,0,0,0,1.11,1.66l4.45-3V19A1,1,0,0,0,16,20Z"/>
            </svg>
            <span class="file-text">
                <strong>Sélectionnez un fichier ou faites un glisser-déposer ici</strong><br>
                Aucun fichier choisi. La taille du fichier ne doit pas dépasser 2Mo.
            </span>
        </label>
        <!-- <label v-else for="attachment-extra" class="file-upload-label d-flex column align-items-start gap-1">
            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19L17 21L21 17M13 3H8.2C7.0799 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.0799 21 8.2 21H12M13 3L19 9M13 3V7.4C13 7.96005 13 8.24008 13.109 8.45399C13.2049 8.64215 13.3578 8.79513 13.546 8.89101C13.7599 9 14.0399 9 14.6 9H19M19 9V13.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="file-text">
                <strong>Fichier choisi: {{ attachment.name }}</strong><br>
                Appuyez sur la croix pour retirer le fichier
            </span>
            <button
                type="button"
                class="position-absolute btn-close"
                @click.stop="handleRemoveFile()"
                aria-label="Supprimer le fichier"
            ></button>
        </label> -->
    </div>
</template>

<script>
export default {
    name: 'AttachmentSection',
    props: {
        attachment: { type: [File, Object], default: null },
        prestation: {
            type: Object,
            required: true
        }
    },
    emits: ['update:attachment'],
    data() {
        return {
            updateTimeout: null,
            // explicitDeleteAttachment = false
        };
    },
    computed: {
        // Pour afficher le nom du fichier
        fileName() {
            if (!this.attachment) return '';
            
            if (this.attachment instanceof File) {
                return this.attachment.name;
            }
            
            return this.attachment.name || 'Fichier existant';
        }
    },
    mounted() {
        console.log('AttachmentSection component mounted with initial attachment:', this.attachment);
        window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll

    },
    methods: {
        setAttachment($event) {
            const file = $event.target.files[0];
            // console.log('📎 AttachmentSection - Fichier sélectionné:', file);
            if (!file) {
                this.$emit('update:attachment', null);
                return;
            }

            const size = file.size / 1024 / 1024;
            if (size <= 2) {
                if (this.updateTimeout) {
                    clearTimeout(this.updateTimeout);
                }
                this.updateTimeout = setTimeout(() => {
                    this.$emit('update:attachment', file);
                    // console.log('✅ Fichier émis:', file.name);
                }, 100);
            } else {
                alert("Le fichier dépasse la taille maximale autorisée de 2 Mo.");
                $event.target.value = null;
                this.$emit('update:attachment', null);
            }
        },
        handleRemoveFile() {
            // console.log('📎 AttachmentSection - Suppression du fichier');
            // this.explicitDeleteAttachment = true;
            this.$emit('update:attachment', null);
            const fileInput = document.getElementById('attachment-extra');
            if (fileInput) fileInput.value = null;
        },
        formatFileSize(bytes) {
            if (!bytes) return 'Taille inconnue';
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
        getDisplaySize() {
            if (!this.attachment) return '';
            
            if (this.attachment instanceof File) {
                return this.formatFileSize(this.attachment.size);
            }
            
            return this.attachment.size ? this.formatFileSize(this.attachment.size) : 'Fichier existant';
        },
    },
    watch: {
        attachment(newVal, oldVal) {
            if (newVal?.name !== oldVal?.name || newVal?.size !== oldVal?.size) {
                console.log('📎 AttachmentSection - Prop attachment changed:', {
                    old: oldVal?.name || oldVal,
                    new: newVal?.name || newVal
                });
            }
        }
    },
    beforeUnmount() {
        // ✅ Cleanup
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
    }
}
</script>

<style scoped>
.required {
    color: #e53e3e;
}
.file-upload-wrapper {
    width: 100%;
    margin-top: 1rem;
}

.file-upload-label {
    border: 2px dashed #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}

.file-upload-label:hover {
    border-color: #667eea;
    background-color: #f7fafc;
}

.file-text {
    font-size: 0.9rem;
    color: #4a5568;
}

.btn-close {
    width: 0.75rem;
    height: 0.75rem;
    padding: 0.25rem;
    top: 8px;
    right: 8px;
    background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/0.75rem auto no-repeat;
    border: 0;
    border-radius: 0.375rem;
    opacity: 0.5;
}

.btn-close:hover {
    opacity: 0.75;
    background-color: rgba(0, 0, 0, 0.1);
}
</style>